<vb-title [title]="video?.title"></vb-title>

<div *ngIf="video" [ngClass]="styles.wrapper" layout="column" layout-wrap="false" [ngStyle]="{ height: height }">

	<vb-loading-spinner *ngIf="isLoadingInitialVideo" flex="fill" flex-align="center" flex-justify="center" layout="row" [size]="'large'">
	</vb-loading-spinner>

	<vb-page-header *ngIf="!isLoadingInitialVideo" [headerText]="video.title">
		<video-playback-processing-progress-bar *ngIf="video.canEditVideo" [isProcessing]="video.isProcessing" [overallProgress]="video.overallProgress" [videoId]="video.id" [videoStatus]="video.status">
		</video-playback-processing-progress-bar>

		<video-playback-settings-menu *ngIf="config.showSettingsMenu" [hidden]="isEditorMode || isOverlayDialogOpen" [mediaFeatures]="mediaFeatures" [videoId]="video.id">
		</video-playback-settings-menu>

		<a *ngIf="config.showCloseBtn" class="glyphicons remove_2" (click)="goToPreviousState()" vbUiBtnPrimaryNgx>
		</a>
	</vb-page-header>

	<preposition-dialog *ngIf="isPrepositionOpen" [ngClass]="styles.overlayDialog" [video]="video" (onClose)="onPrepositionDialogClose()">
	</preposition-dialog>

	<replace-video-dialog *ngIf="canEditVideo" [ngClass]="styles.overlayDialog" [hidden]="!isReplaceVideoOpen" [isOpen]="isReplaceVideoOpen" [video]="video" (onClose)="onReplaceVideoDialogClose()">
	</replace-video-dialog>

	<approval-process-container *ngIf="config.showApprovalProcess
			&& isUserAuthenticated
			&& !isLoadingInitialVideo
			&& !video.legalHold" [video]="video" (deleteVideoEvent)="deleteVideo()">
	</approval-process-container>

	<vb-ui-sidebar-layout *ngIf="!isLoadingInitialVideo && !isReportsOpen" #sidebarLayout flex="fill" [hideSidebar]="isEditorMode || !config.showSidebar" [sidebarConfig]="sidebarConfig" [themed]="false" [ngClass]="[styles.sidebarLayout]" (onSidebarToggle)="onSidebarToggle($event)">
		<div slot="mainContent">
			<div layout="column" layout-wrap="false" [ngClass]="styles.fill">
				<vb-loading-spinner *ngIf="isLoadingNewVideo" flex="fill" flex-align="center" flex-justify="center" layout="row" [size]="'large'">
				</vb-loading-spinner>

				<div *ngIf="!isLoadingNewVideo" flex="fill" flex-justify="center" flex-align="stretch" layout="column" layout-gt-md="row" layout-wrap="false">

					<div flex="fill" flex-align="center" flex-justify="center" layout [ngClass]="styles.playerRegion" [vbWatchDimensions]="[videoPlaybackWrapper]">
						<div #videoPlaybackWrapper class="video-playback-player-wrapper">
							<video-text-status *ngIf="!isRecordingStatusSurfaced" [approvalStatus]="video.approval.status" [videoIsActive]="video.isActive" [isUnlisted]="video.unlisted" [hasMediaEditAuth]="hasMediaEditAuth || video.canEditVideo" [isVideoOwner]="isVideoOwner" [isOnLegalHold]="video.legalHold">
							</video-text-status>

							<video-playback-status-msg *ngIf="!isRecordingStatusSurfaced && playableStatus" [pageStatus]="{active: true}" [playableStatus]="playableStatus" [showRestoreBtn]="video.isReplacing" [videoId]="video.id">
							</video-playback-status-msg>

							<recording-process *ngIf="isRecordingStatusSurfaced" class="text-white" [video]="video">
							</recording-process>

							<vb-video-player *ngIf="isReadyToPlay" [autoPlay]="params.autoplay" [durationMs]="video.duration" [hasAudioOnly]="video.hasAudioOnly" [heartbeatIntervalSecs]="video.heartbeatInterval" [is360]="video.is360" [isCaptionsAvailable]="video.closedCaptionsEnabled" [live]="video.isLive" [muteBtnOnLeft]="isMuteBtnOnLeft" [playerConfig]="{ isElectronMobileApp: config.isElectronMobileApp }" (onPlay)="onPlay()" (onPlaybackEnded)="onPlaybackEnded()" (onPlayerReady)="onPlayerReady($event.vgAPI)" [playbacks]="video.playbacks" [resumeSessionId]="video.sessionId" [sourceType]="video.sourceType" [startAt]="video.initialStartAt?.startAt" [startAtResume]="video.initialStartAt?.startAtResume" [subtitles]="video.subtitles" [thumbnailCfg]="video.thumbnailCfg" [thumbnailUri]="video.thumbnailUri || (video.hasAudioOnly ? '/shared/img/audio-thumbnail.png' : '')" [timeMarkers]="markers" [videoId]="video.id" [videoTitle]="video.title">
							</vb-video-player>
						</div>
					</div>

					<div *ngIf="video.chapterInfo.hasChapters && isReadyToPlay" [ngClass]="[styles.chaptersRegion, chapterImagesToggle ? 'chaptersHidden' : '']" flex-align="stretch" flex-justify="center" layout>
						<video-chapter-renderer [hidden]="chapterImagesToggle" [chapterInfo]="video.chapterInfo" [currentTime]="vgAPI?.currentTime" flex="1">
						</video-chapter-renderer>

						<aside class="chapter-image-toggle">
							<a class="chapter-image-toggler theme-accent-link" [attr.aria-label]="'Media_Chapters_ToggleButton' | translate " (click)="chapterImagesToggle = !chapterImagesToggle" [tooltip]="ttTemplate" [placement]="'bottom'" [container]="'body'">
								<ng-template #ttTemplate>{{ (chapterImagesToggle ? 'Media_Chapters_Show' : 'Media_Chapters_Hide') | translate }}</ng-template>
								<span class="glyphicons font-20" [ngClass]="chapterImagesToggle ? 'eye_open' : 'eye_close'"></span>
							</a>
						</aside>
					</div>
				</div>

				<video-playlist-carousel *ngIf="playlistId && !isEditorMode" flex="48px" [currentVideoId]="videoId" [videos]="playlist?.videos" (onSelectionChanged)="loadPlaylistVideo($event.videoId)">
				</video-playlist-carousel>
			</div>
		</div>

		<div slot="sidebarHeaderControls">
			<vb-ui-search-input *ngIf="isSidebarHeaderFilterSurfaced" [ngClass]="styles.sidebarHeaderSearchInput" [(ngModel)]="sidebarFilter" [placeholder]="'Media_Videos_Search_SearchPlaceholder' | translate">
			</vb-ui-search-input>
		</div>

		<div slot="sidebarPanel">
			<video-playback-sidebar-panel [selectedButtonId]="activeSidebarButtonId" (onCloseSidebar)="onCloseSidebar()">
			</video-playback-sidebar-panel>
		</div>
	</vb-ui-sidebar-layout>

	<video-playback-reports *ngIf="isReportsOpen" flex="fill" [video]="video" (onClose)="onVideoPlaybackReportsClose()">
	</video-playback-reports>
</div>
